<template>
  <div
  id="modal"
  class="bg"
  @click.self="closeModal">
    <div class="modal-container">
      <header>
        <slot name="header">&nbsp;</slot>
        <span class="close" @click="closeModal">&times;</span>
      </header>
      <div class="body">
        <slot>Some text</slot>
      </div>
      <footer>
        <slot name="footer">some buttons</slot>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closeModal: function() {
      this.$emit("closeModal");
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}
.modal-container {
  background-color: $white;
  padding: 20px 30px;
  display: flex;
  flex-direction: column;
  max-width: 50vw;
  max-height: 150vh;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .close {
      padding: 5px 10px;
      font-size: 2rem;
      font-weight: bold;
      cursor: pointer;
    }
  }

  .body {
    margin: 20px 0;
  }
}
</style>